import { render, staticRenderFns } from "./StockInvoiceStakeholderItems.vue?vue&type=template&id=13692f88&scoped=true&"
import script from "./StockInvoiceStakeholderItems.vue?vue&type=script&lang=js&"
export * from "./StockInvoiceStakeholderItems.vue?vue&type=script&lang=js&"
import style0 from "./StockInvoiceStakeholderItems.vue?vue&type=style&index=0&id=13692f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13692f88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSheet,VSimpleTable,VSwitch,VTextField})
